import learnylib from '../../../img/logo.svg';
import cisco from '../../../img/cisco.png';
import academieDuSourire from '../../../img/academie_du_sourire.png';
import BackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
import useCourse from '../Hooks/useCourse';

const defaultLogo = {img: learnylib, h: 45};

const logos = [
    {siret: '49198279900034', img: academieDuSourire, h: 60},
    {siret: '51146662500015', img: cisco, h: 55},
];

export default function Logo({onClose}){

    const course = useCourse();

    const logo = logos.find(l => l.siret === course?.siret?.toString()) || defaultLogo;

    return <div className='study-logo'>

        <Link to="/enrollments">
            <BackIcon 
                sx={{color: 'white', cursor: 'pointer'}} 
            />
        </Link>

        <img src={logo.img} alt='Logo' width={200} height={logo.h} />

        <div className='study-desktop-hidden'>
            <CloseIcon sx={{color: 'white', cursor: 'pointer'}} onClick={onClose} />
        </div>

    </div>
}
